import { render } from "./startup-application-form.vue?vue&type=template&id=e8f153b2&ts=true"
import script from "./startup-application-form.vue?vue&type=script&lang=ts"
export * from "./startup-application-form.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__